module.exports = __webpack_public_path__ + "static/img/20221213_02.a0f649b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221213_02.png
// module id = mJ5+
// module chunks = 0